import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/Table';
import { Text } from '@/ui';
import { useTranslation } from 'react-i18next';
import Menus from '@/components/Menus/Menus';
import { Link, useLocation } from 'react-router-dom';
import styles from './styles.module.css';
import { OrganizationResponse } from '@/store/slices/organizationsSlice';
import { formatCurrency } from '@/utils/currency';

type Props = {
  organizations: OrganizationResponse[];
};

function OrganizationsTable({ organizations }: Props) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  return (
    <Menus>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>
              <Text size='s' color='base-blue'>
                {t('Accounts.account_name')}
              </Text>
            </TableHead>
            <TableHead>
              <Text size='s' color='base-blue'>
                {t('Accounts.type')}
              </Text>
            </TableHead>
            <TableHead>
              <Text size='s' color='base-blue'>
                {t('Accounts.companies')}
              </Text>
            </TableHead>
            <TableHead>
              <Text size='s' color='base-blue'>
                {t('Accounts.transaction_count')}
              </Text>
            </TableHead>
            <TableHead className='text-right'>
              <Text size='s' color='base-blue'>
                {t('Accounts.total_payment_value')}
              </Text>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {organizations.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} className='text-center'>
                <Text size='xs' color='base-blue' weight='light-medium'>
                  {t('Accounts.no_accounts_found')}
                </Text>
              </TableCell>
            </TableRow>
          ) : (
            organizations.map((organization) => (
              <TableRow key={organization._id}>
                <TableCell>
                  <Link to={`${pathname}/${organization._id}`} className={styles.accountLink}>
                    <Text size='xs' color='blue' weight='light-medium'>
                      {organization.name ?? '-'}
                    </Text>
                  </Link>
                </TableCell>
                <TableCell>
                  <Text size='xs' color='base-blue' weight='light-medium'>
                    {organization.type ? t(`Accounts.${organization.type}`) : '-'}
                  </Text>
                </TableCell>
                <TableCell>
                  <Text size='xs' color='base-blue' weight='light-medium'>
                    {organization.numberOfCompanies ?? '0'}
                  </Text>
                </TableCell>
                <TableCell>
                  <Text size='xs' color='base-blue' weight='light-medium'>
                    {Intl.NumberFormat('en-US', {
                      notation: 'compact',
                      maximumFractionDigits: 1,
                    }).format(organization?.totalTransaction ?? 0)}
                  </Text>
                </TableCell>
                <TableCell className='text-right'>
                  <Text size='xs' color='base-blue' weight='light-medium'>
                    {organization.currency
                      ? formatCurrency(organization.totalPaymentVolume ?? 0, organization.currency)
                      : String(organization.totalPaymentVolume ?? 0)}
                  </Text>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </Menus>
  );
}

export default OrganizationsTable;
